import * as paper from 'paper';
import {Size} from "paper";
import {EDIT_MODES} from "./includes/applicationState";
import {ApiService, ItemSelectionList, IdDescriptionPair} from "./includes/apiService";
import {EdgeColorData} from "./drawData";
import {EEToolAdapterContextType} from "../types/EEToolAdapterContextType";
import {PopupLocation} from "../types/PopupLocation";
import {PopupSize} from "../types/PopupSize";

export class DrawingCanvasFormSide {
    static DEFAULTBUMPWIDTH_INCHES = 20;
    static DEFAULTBUMPDEPTH_INCHES = 5;
    static DEFAULT_OTHER_SPLASH_HEIGHT = 5;

    static dc_makeSplashFunction(setupLogicFunc: any, drawLogicFunc: (height: number) => void, adapter: EEToolAdapterContextType) {
        return () => {
            var reqData = setupLogicFunc();
            adapter.setSplashHeightHandler((height) => {
                drawLogicFunc(height);
            });
            DrawingCanvasFormSide.dc_showSelSplashHeightDlg(reqData.modalLocation, DrawingCanvasFormSide.DEFAULT_OTHER_SPLASH_HEIGHT, adapter);
        }
    }

    static dc_makeCookTopSplashFunction(setupLogicFunc: any, size: any, drawLogicFunc: (width: number, height: number) => void, adapter: EEToolAdapterContextType) {
        return () => {
            var reqData = setupLogicFunc();
            adapter.setCookTopSplashHandler((width, height) => {
                drawLogicFunc(width, height);
            });

            DrawingCanvasFormSide.dc_showSelCookTopSplashDlg(reqData.modalLocation, size.width, size.height, adapter);
        }
    }

    static dc_makeRadiusLineFunction(setupLogicFunc: any, radiusLogicFunc: (radDepth: number, radDirection: number) => void, adapter: EEToolAdapterContextType) {
        return () => {
            var reqData = setupLogicFunc();
            if (!reqData) {
                return;
            }
            adapter.setFullRadiusHandler((radDepth, radDirection) => radiusLogicFunc(radDepth, radDirection));
            DrawingCanvasFormSide.dc_showRadiusDlg(reqData.modalLocation, reqData.inches, reqData.direction, adapter);
        };
    }

    static dc_verifyModalLocIsOnScreen(loc: any, size: any) {
        var maxY = window.innerHeight - (size.height + 20);//enough room for a scrollbar.
        var maxX = window.innerWidth - (size.width + 20);
        if (loc.left > maxX) {
            loc.left = maxX;
        }
        if (loc.top > maxY) {
            loc.top = maxY;
        }
    }

    static dc_showModal(name: string, loc: PopupLocation, size: any, adapter: EEToolAdapterContextType) {
        DrawingCanvasFormSide.dc_verifyModalLocIsOnScreen(loc, size);
        switch (name) {
            case 'prdAndBgModal': {
                adapter.showPopupColor(loc, size as PopupSize);
                break;
            }
            case 'fullRadiusModal': {
                adapter.showPopupFullRadius(loc, size as PopupSize);
                break;
            }
            case 'bumpModal': {
                adapter.showPopupBump(loc, size as PopupSize);
                break;
            }
            case 'selDepthModal': {
                adapter.showPopupSelDepth(loc, size as PopupSize);
                break;
            }
            case 'selCookTopSplashModal': {
                adapter.showPopupCookTopSplash(loc, size as PopupSize);
                break;
            }
            case 'selSplashHeightModal': {
                adapter.showPopupSplashHeight(loc, size as PopupSize);
                break;
            }

            default:
                throw new Error('Unknown modal: ' + name);
        }
    }

    static dc_showModalWithOptions(name: string, loc: PopupLocation, size: any, adapter: EEToolAdapterContextType, title: string, val: number | undefined, options: IdDescriptionPair[]) {
        DrawingCanvasFormSide.dc_verifyModalLocIsOnScreen(loc, size);
        switch (name) {
            case 'laminateModal': {
                adapter.showPopupLaminate(title, val, options, loc, size as PopupSize);
                break;
            }
            case 'selDepthModal': {
                adapter.showPopupSelDepthWithOptions(val, options, loc, size as PopupSize);
                break;
            }

            default:
                throw new Error('Unknown modal: ' + name);
        }
    }


    static dc_showEdgeColorForm(loc: PopupLocation, ec: EdgeColorData, adapter: EEToolAdapterContextType) {
        adapter.setEdgeColorP(ec.p);
        adapter.setEdgeColorC(ec.c ?? 0);
        if (ec.e1 === 'none') {
            adapter.setEdgeColorE1(0);
        } else {
            adapter.setEdgeColorE1(ec.e1 as number);
        }
        DrawingCanvasFormSide.dc_showModal('prdAndBgModal', loc, new Size(380, 400), adapter);
    }

    static dc_switchToCanvas() {
        //TODO:
        /*
        DrawingCanvasFormSide.dc_hideAllModals();
        $("#quoteInfoPlaceHolder").hide();
        $("#canvasHolder").removeClass("hide").show();
        $("#stuffHolder").removeClass("hide");
         */
    }

    static dc_switchToQuoteInfo() {
        //TODO: __doPostBack('DRAWING_TOOL_TAB', 1);
    }

    static saveImageToServer(canvas: HTMLCanvasElement) {
        //TODO:
        /*
        var imageData = canvas.toDataURL('image/png');
        imageData = imageData.replace('data:image/png;base64,', '');
        var quoteId = BrowserHelper.getParameterByName("QuoteID");
        var page = BrowserHelper.getParameterByName("portal_menu_item_id");
        if ((page === "STORE_TEMP_QUOTE_TOOL" || page === "CFI_TEMP_QUOTE_TOOL") && quoteId !== "") {
            if (imageData != null) {
                ApiService.saveQuoteDrawing(imageData, quoteId);
            }
        }
         */
    }

    static dc_showSelSplashHeightDlg(loc: any, height: number, adapter: EEToolAdapterContextType) {
        adapter.setSplashHeight(height)
        DrawingCanvasFormSide.dc_showModal('selSplashHeightModal', loc, new Size(340, 240), adapter);
    }

    static dc_showSelCookTopSplashDlg(loc: any, width: number, height: number, adapter: EEToolAdapterContextType) {
        adapter.setCookTopSplashWidth(width);
        adapter.setCookTopSplashHeight(height);
        DrawingCanvasFormSide.dc_showModal('selCookTopSplashModal', loc, new Size(420, 300), adapter);
    }

    static dc_showSelDepthDlg(loc: any, depth: number, optionalProducts: IdDescriptionPair[] | undefined, adapter: EEToolAdapterContextType, selectedProduct = undefined) {
        adapter.setSelDepth(depth);
        adapter.setSelDepthOptionalProduct(selectedProduct);
        if (optionalProducts) {
            DrawingCanvasFormSide.dc_showModalWithOptions('selDepthModal', loc, new Size(280, 300), adapter, '', selectedProduct, optionalProducts);
        } else {
            DrawingCanvasFormSide.dc_showModal('selDepthModal', loc, new Size(280, 240), adapter);
        }
    }

    static dc_showBumpDlg(loc: any, measurementsInInches: {
        width: number,
        depth: number
    }, adapter: EEToolAdapterContextType) {
        adapter.setBumpWidth(measurementsInInches.width);
        adapter.setBumpDepth(measurementsInInches.depth);
        DrawingCanvasFormSide.dc_showModal('bumpModal', loc, new Size(440, 300), adapter);
    }

    static dc_showLaminateDlg(loc: any, title: string, items: IdDescriptionPair[], adapter: EEToolAdapterContextType, value: number | undefined) {
        DrawingCanvasFormSide.dc_showModalWithOptions('laminateModal', loc, new Size(280, 250), adapter, title, value, items);
    }

    static dc_showRadiusDlg(loc: any, depth: any, direction: any, adapter: EEToolAdapterContextType) {
        adapter.setRadDepth(depth);
        if (direction) {
            adapter.setRadDirection(direction);
        }
        DrawingCanvasFormSide.dc_showModal('fullRadiusModal', loc, new Size(440, 300), adapter);
    }

    static dc_changeMouseCursor(canvas: HTMLCanvasElement, cursorStyle: string) {
        /* cursorStyle values:
        auto        move           no-drop      col-resize
        all-scroll  pointer        not-allowed  row-resize
        crosshair   progress       e-resize     ne-resize
        default     text           n-resize     nw-resize
        help        vertical-text  s-resize     se-resize
        inherit     wait           w-resize     sw-resize
        
        hand
        */

        /* Custom cursor: pencil-cursor */

        if (canvas) {
            if (canvas.style) {
                if (cursorStyle === "pencil-cursor") {
                    canvas.classList.add('ee-tool-pencil-cursor');
                } else {
                    canvas.classList.remove('ee-tool-pencil-cursor');
                    canvas.style.cursor = cursorStyle;
                }
            }
        }
    }

    //** Change guide according editMode  */
    static changeGuideMode(editMode: EDIT_MODES) {
        //TODO:
        /*
        switch (editMode) {
            case EDIT_MODES.QUOTE_INFORMATION:
                {
                    break;
                }
            case EDIT_MODES.DRAW_COUNTERS:
                {
                    $('#floatEstimateToggle').removeClass("toggleHide");
                    $('#floatToggle').removeClass("toggleHide");
                    $('#floatToggle').removeClass("imageAddMaterialEding");
                    $('#floatToggle').removeClass("imageDrawBumpsRadiuses");
                    $('#floatToggle').removeClass("imageBackSplashCutouts");
                    $('#floatToggle').removeClass("imageSinkCookTop");
                    $('#floatToggle').removeClass("imageReviewPricingPrint");

                    $('#floatToggle').addClass("imageDrawCounterTop");
                    break;
                }
            case EDIT_MODES.EDGE_COLOR:
                {
                    $('#floatEstimateToggle').removeClass("toggleHide");
                    $('#floatToggle').removeClass("toggleHide");
                    $('#floatToggle').removeClass("imageDrawCounterTop");
                    $('#floatToggle').removeClass("imageDrawBumpsRadiuses");
                    $('#floatToggle').removeClass("imageBackSplashCutouts");
                    $('#floatToggle').removeClass("imageSinkCookTop");
                    $('#floatToggle').removeClass("imageReviewPricingPrint");

                    $('#floatToggle').addClass("imageAddMaterialEding");
                    break;
                }
            case EDIT_MODES.BUMPS_RADIUSES:
                {
                    $('#floatEstimateToggle').removeClass("toggleHide");
                    $('#floatToggle').removeClass("toggleHide");
                    $('#floatToggle').removeClass("imageDrawCounterTop");
                    $('#floatToggle').removeClass("imageAddMaterialEding");
                    $('#floatToggle').removeClass("imageBackSplashCutouts");
                    $('#floatToggle').removeClass("imageSinkCookTop");
                    $('#floatToggle').removeClass("imageReviewPricingPrint");

                    $('#floatToggle').addClass("imageDrawBumpsRadiuses");
                    break;
                }
            case EDIT_MODES.BACKSPLASH:
                {
                    $('#floatEstimateToggle').removeClass("toggleHide");
                    $('#floatToggle').removeClass("toggleHide");
                    $('#floatToggle').removeClass("imageDrawCounterTop");
                    $('#floatToggle').removeClass("imageAddMaterialEding");
                    $('#floatToggle').removeClass("imageDrawBumpsRadiuses");
                    $('#floatToggle').removeClass("imageSinkCookTop");
                    $('#floatToggle').removeClass("imageReviewPricingPrint");

                    $('#floatToggle').addClass("imageBackSplashCutouts");
                    break;
                }
            case EDIT_MODES.SINK_COOKTOP:
                {
                    $('#floatEstimateToggle').removeClass("toggleHide");
                    $('#floatToggle').removeClass("toggleHide");
                    $('#floatToggle').removeClass("imageDrawCounterTop");
                    $('#floatToggle').removeClass("imageAddMaterialEding");
                    $('#floatToggle').removeClass("imageDrawBumpsRadiuses");
                    $('#floatToggle').removeClass("imageBackSplashCutouts");
                    $('#floatToggle').removeClass("imageReviewPricingPrint");

                    $('#floatToggle').addClass("imageSinkCookTop");
                    break;
                }
            case EDIT_MODES.OPTIONAL_ITEM:
                {
                    $('#floatToggle').addClass("toggleHide");
                    $('#floatEstimateToggle').addClass("toggleHide");
                    break;
                }
            case EDIT_MODES.PRICING_PRINTING:
                {
                    $('#floatEstimateToggle').removeClass("toggleHide");
                    $('#floatToggle').removeClass("toggleHide");
                    $('#floatToggle').removeClass("imageDrawCounterTop");
                    $('#floatToggle').removeClass("imageAddMaterialEding");
                    $('#floatToggle').removeClass("imageDrawBumpsRadiuses");
                    $('#floatToggle').removeClass("imageBackSplashCutouts");
                    $('#floatToggle').removeClass("imageSinkCookTop");

                    $('#floatToggle').addClass("imageReviewPricingPrint");
                    break;
                }
        }
         */
    }
}
